import EfShopingCart from '@elem/ui/ef-shoping-cart';

export default function GloCart() {
    return (
        <>
            <EfShopingCart />
        </>
    );
}
